import { INavigationPagesService } from '../iNavigationPagesService'
import { INavigationPage } from '../iNavigationPage';
import { ISessionService } from '../../../core/sessions/sessionService';
import { UserInfo } from '../../userInfo/models/userInfo';
import { UserInfoService } from '../../userInfo/services/userInfoService';

export class SidenavController implements ng.IController {

    authorizedPages: INavigationPage[];
    
    static $inject: string[] = ['$http', '$state', '$scope', '$mdDialog', '$q', 'SessionService', 'NavigationPagesService', 'UserInfoService'];

    constructor(
        private _$http: angular.IHttpService,
        private $state: ng.ui.IStateService,
        private $scope: ng.IScope,
        private $mdDialog: angular.material.IDialogService,
        private $q: angular.IQService,
        private sessionService: ISessionService,
        private navigationPagesService: INavigationPagesService,
        private userInfoService: UserInfoService
    ) {
    }

    $onInit() {
        this.setAuthorizedPages();
        this.$scope.$on('$authorizationCacheChanged', () => {
            this.setAuthorizedPages();
        });
    }

    logout(): void {
        this.sessionService.logout('logout');
    }

    setAuthorizedPages(): void {
        this.authorizedPages = [];
        this.navigationPagesService.getNavigationPages().forEach((page: INavigationPage) => {
            this.authorizedPages.push(page);
        });
    }


    getName(): string {
        if (!this.userInfoService.getUserInfo())
            return 'Loading User...';
        const cUserInfo = this.userInfoService.getUserInfo();
        return cUserInfo.name;
	}

	getRole(): string {
		if (!this.userInfoService.getUserInfo())
			return 'Loading Role...';
		const cUserInfo = this.userInfoService.getUserInfo();
		return cUserInfo.role;
	}

    private getRootStateName(): string {
        if (this.$state.current.data && this.$state.current.data.navParent)
            return this.$state.current.data.navParent;

        return this.$state.current.name;
    }

    generateReport(event: MouseEvent): void {
        this.generateDialogShow(event);
    }

    private generateDialogShow(event: MouseEvent) {
        this.$mdDialog.show({
            template: `<md-dialog flex aria-label="GenerateReport"><generate-report layout-fill></generate-report></md-dialog>`,
            parent: angular.element(document.body),
            targetEvent: event,
            onComplete: () => {
                angular.element(document.querySelector('md-dialog')).addClass('min-size-personnel');
            },
            controller: () => { },
            bindToController: true,
            controllerAs: 'vm'
        });

    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/navigation/sidenav/sidenavController.ts
 **/